import React from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { useSearchParams } from "react-router-dom";
import { TimeService, getMomentTz } from "@dexteel/mesf-core";
import { useWorkOrdersFilters } from "../hooks/useWorkOrdersFilters";
import { cmmsTheme } from "@setup/theme/cmms-theme";
import { useDateFilterDraft } from "@/shared/hooks/useDateFilterDraft";

const moment = getMomentTz();

type Props = {};

export const EndFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { start: Start, end: End } = useWorkOrdersFilters();

	const handleDateChange = (date: any) => {
		if (date && moment(date).isValid()) {
			const selectedDate = moment(date).endOf("day");
			const startDate = moment(Start);
			const today = moment();

			if (selectedDate.isAfter(today, "day")) {
				return;
			}

			if (startDate.isValid() && selectedDate.isBefore(startDate, "day")) {
				const startIsoString = selectedDate
					.clone()
					.startOf("day")
					.toDate()
					.toISOString();
				const endIsoString = selectedDate.toDate().toISOString();
				searchParams.set("start", encodeURIComponent(startIsoString));
				searchParams.set("end", encodeURIComponent(endIsoString));
				setSearchParams(searchParams, { replace: true });
			} else {
				const isoString = selectedDate.toDate().toISOString();
				searchParams.set("end", encodeURIComponent(isoString));
				setSearchParams(searchParams, { replace: true });
			}
		}
	};

	const { pickerProps, textFieldProps } = useDateFilterDraft(
		moment(End),
		handleDateChange,
	);

	return (
		<DatePicker
			label="End"
			timezone={TimeService.getInstance().getServerTimeZone()}
			format="MM/DD/YYYY"
			{...(pickerProps as any)}
			maxDate={moment() as any}
			slotProps={{
				textField: {
					...textFieldProps,
					fullWidth: true,
					variant: "outlined",
					margin: "dense",
					InputProps: {
						style: {
							height: cmmsTheme.dimensions.standardInput,
							marginTop: cmmsTheme.spacing.inputOffset,
						},
					},
					InputLabelProps: {
						style: {
							fontSize: "14px",
						},
					},
				},
			}}
		/>
	);
};
